(function () {
  class KhelspaceCardPurchase extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.select = this.querySelector('[data-purchase-select]');
      if (!this.select) return;
      this.select.addEventListener('change', () => this.update());
      this.update();
    }
    update() {
      const option = this.select.selectedOptions[0];
      if (!option) return;
      const saving = Number(option.dataset.discount) > 0;
      this.querySelector('[data-purchase-price]').textContent = option.dataset.price;
      const compare = this.querySelector('[data-purchase-compare]');
      compare.textContent = option.dataset.compare;
      compare.hidden = !saving;
      const discount = this.querySelector('[data-purchase-saving]');
      discount.textContent = option.dataset.saving;
      discount.hidden = !saving;
      this.querySelector('[data-purchase-quantity]').value = option.dataset.min || '1';
      const button = this.querySelector('button[type="submit"]');
      button.disabled = option.disabled;
      button.textContent = option.disabled ? this.dataset.sold : this.dataset.addText;
      button.setAttribute('aria-label', option.disabled ? this.dataset.sold : `${this.dataset.addLabel} — ${option.dataset.label}`);
      const card = this.closest('[data-purchase-card]');
      if (!card) return;
      card.querySelectorAll('[data-purchase-product-link]').forEach(link => { link.href = option.dataset.url; });
      const badge = card.querySelector('.ksm-product-card__badge');
      if (badge) badge.hidden = !saving;
    }
  }
  if (!customElements.get('ksm-card-purchase')) customElements.define('ksm-card-purchase', KhelspaceCardPurchase);
})();
